import * as Yup from 'yup';

export const validationSchema = Yup.object({
  insurance_carrier_id: Yup.number().required('Insurance Carrier is required'),
  custom_carrier: Yup.string(),
});
